import React from "react";
import ContactForm from "../Components/ContactForm";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import Image1 from "../Images/image 1.png";

function Contact() {
  return (
    <div className="contact-page">
      <section className="inner-hero">
        <div className="inner-hero-bg">
          <img src={Image1} alt="" className="inner-hero-img" />
        </div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">GET IN TOUCH</span>
          <h1>Contact Us</h1>
          <p>Get a free estimate on your next project</p>
          <div className="inner-hero-breadcrumb">
            <Link to="/">Home</Link> <span>/</span> Contact
          </div>
        </div>
      </section>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Contact;
